/**
 * Route wiring for each application. Wiring only.
 *
 * Names, descriptions, status and who may open an application all come from the backend registry
 * at `backend/app/core/apps.py`, over /platform/apps. This file must never restate them: one
 * fact, one home. `registry.test.ts` asserts the two registries name the same applications.
 */
import type { AppId } from '@/types';

export const APP_PATHS: Record<AppId, string> = {
  census: '/census',
  rfp: '/rfp',
  proposals: '/proposals',
  trenching: '/trenching',
  presentations: '/presentations',
  packets: '/packets',
};

/** Registry order, which is the order the front door and the switcher present. */
export const APP_IDS = Object.keys(APP_PATHS) as AppId[];

/** The application a path belongs to, or undefined for a platform page. */
export function appIdForPath(pathname: string): AppId | undefined {
  return APP_IDS.find(
    (id) => pathname === APP_PATHS[id] || pathname.startsWith(`${APP_PATHS[id]}/`),
  );
}
